import {displaySuccessFlash, displayErrorFlash} from "servos/ajaxFlash";
import ActionCable      from '@rails/actioncable';

class Controller {
  call() {
    document.controller = this

    // Display flash messages from AJAX responses
    displaySuccessFlash.call(this);

    // Display flash messages from AJAX responses
    displayErrorFlash.call(this);
  }
}


export default Controller
